import { defineComponent as De, ref as s, computed as c, watchEffect as Oe, onMounted as Ue, onBeforeUnmount as Ie, h as v, Fragment as _e, Transition as se, mergeProps as je } from "vue";
import Fe from "./ghl-ui.es1544.js";
import fe from "./ghl-ui.es827.js";
import Ne from "./ghl-ui.es826.js";
import { useRtl as Ve } from "./ghl-ui.es823.js";
import Ae from "./ghl-ui.es699.js";
import { useReactivated as Ge } from "./ghl-ui.es1468.js";
import { off as C, on as O } from "./ghl-ui.es694.js";
import ke from "./ghl-ui.es1139.js";
import { useThemeClass as qe } from "./ghl-ui.es829.js";
import ce from "./ghl-ui.es845.js";
import { Wrapper as ue } from "./ghl-ui.es1516.js";
import { getPreciseEventTarget as Je } from "./ghl-ui.es881.js";
const Ke = Object.assign(Object.assign({}, fe.props), {
  size: {
    type: Number,
    default: 5
  },
  duration: {
    type: Number,
    default: 0
  },
  scrollable: {
    type: Boolean,
    default: !0
  },
  xScrollable: Boolean,
  trigger: {
    type: String,
    default: "hover"
  },
  useUnifiedContainer: Boolean,
  triggerDisplayManually: Boolean,
  // If container is set, resize observer won't not attached
  container: Function,
  content: Function,
  containerClass: String,
  containerStyle: [String, Object],
  contentClass: [String, Array],
  contentStyle: [String, Object],
  horizontalRailStyle: [String, Object],
  verticalRailStyle: [String, Object],
  onScroll: Function,
  onWheel: Function,
  onResize: Function,
  internalOnUpdateScrollLeft: Function,
  internalHoistYRail: Boolean
}), de = De({
  name: "Scrollbar",
  props: Ke,
  inheritAttrs: !1,
  setup(o) {
    const {
      mergedClsPrefixRef: S,
      inlineThemeDisabled: f,
      mergedRtlRef: $
    } = Ne(o), r = Ve("Scrollbar", $, S), X = s(null), g = s(null), H = s(null), B = s(null), p = s(null), d = s(null), h = s(null), T = s(null), z = s(null), E = s(null), D = s(null), M = s(0), L = s(0), U = s(!1), I = s(!1);
    let _ = !1, j = !1, m, R, q = 0, J = 0, F = 0, K = 0;
    const he = Ae(), N = c(() => {
      const {
        value: e
      } = T, {
        value: n
      } = d, {
        value: t
      } = E;
      return e === null || n === null || t === null ? 0 : Math.min(e, t * e / n + o.size * 1.5);
    }), ve = c(() => `${N.value}px`), V = c(() => {
      const {
        value: e
      } = z, {
        value: n
      } = h, {
        value: t
      } = D;
      return e === null || n === null || t === null ? 0 : t * e / n + o.size * 1.5;
    }), me = c(() => `${V.value}px`), Re = c(() => {
      const {
        value: e
      } = T, {
        value: n
      } = M, {
        value: t
      } = d, {
        value: l
      } = E;
      if (e === null || t === null || l === null)
        return 0;
      {
        const a = t - e;
        return a ? n / a * (l - N.value) : 0;
      }
    }), Se = c(() => `${Re.value}px`), be = c(() => {
      const {
        value: e
      } = z, {
        value: n
      } = L, {
        value: t
      } = h, {
        value: l
      } = D;
      if (e === null || t === null || l === null)
        return 0;
      {
        const a = t - e;
        return a ? n / a * (l - V.value) : 0;
      }
    }), we = c(() => `${be.value}px`), Q = c(() => {
      const {
        value: e
      } = T, {
        value: n
      } = d;
      return e !== null && n !== null && n > e;
    }), Z = c(() => {
      const {
        value: e
      } = z, {
        value: n
      } = h;
      return e !== null && n !== null && n > e;
    }), ge = c(() => {
      const {
        trigger: e
      } = o;
      return e === "none" || U.value;
    }), Be = c(() => {
      const {
        trigger: e
      } = o;
      return e === "none" || I.value;
    }), y = c(() => {
      const {
        container: e
      } = o;
      return e ? e() : g.value;
    }), pe = c(() => {
      const {
        content: e
      } = o;
      return e ? e() : H.value;
    }), ee = Ge(() => {
      o.container || ne({
        top: M.value,
        left: L.value
      });
    }), ye = () => {
      ee.isDeactivated || x();
    }, xe = (e) => {
      if (ee.isDeactivated)
        return;
      const {
        onResize: n
      } = o;
      n && n(e), x();
    }, ne = (e, n) => {
      if (!o.scrollable)
        return;
      if (typeof e == "number") {
        P(e, n ?? 0, 0, !1, "auto");
        return;
      }
      const {
        left: t,
        top: l,
        index: a,
        elSize: u,
        position: b,
        behavior: i,
        el: w,
        debounce: Y = !0
      } = e;
      (t !== void 0 || l !== void 0) && P(t ?? 0, l ?? 0, 0, !1, i), w !== void 0 ? P(0, w.offsetTop, w.offsetHeight, Y, i) : a !== void 0 && u !== void 0 ? P(0, a * u, u, Y, i) : b === "bottom" ? P(0, Number.MAX_SAFE_INTEGER, 0, !1, i) : b === "top" && P(0, 0, 0, !1, i);
    }, Te = (e, n) => {
      if (!o.scrollable)
        return;
      const {
        value: t
      } = y;
      t && (typeof e == "object" ? t.scrollBy(e) : t.scrollBy(e, n || 0));
    };
    function P(e, n, t, l, a) {
      const {
        value: u
      } = y;
      if (u) {
        if (l) {
          const {
            scrollTop: b,
            offsetHeight: i
          } = u;
          if (n > b) {
            n + t <= b + i || u.scrollTo({
              left: e,
              top: n + t - i,
              behavior: a
            });
            return;
          }
        }
        u.scrollTo({
          left: e,
          top: n,
          behavior: a
        });
      }
    }
    function ze() {
      Ce(), Xe(), x();
    }
    function Me() {
      A();
    }
    function A() {
      Pe(), We();
    }
    function Pe() {
      R !== void 0 && window.clearTimeout(R), R = window.setTimeout(() => {
        I.value = !1;
      }, o.duration);
    }
    function We() {
      m !== void 0 && window.clearTimeout(m), m = window.setTimeout(() => {
        U.value = !1;
      }, o.duration);
    }
    function Ce() {
      m !== void 0 && window.clearTimeout(m), U.value = !0;
    }
    function Xe() {
      R !== void 0 && window.clearTimeout(R), I.value = !0;
    }
    function He(e) {
      const {
        onScroll: n
      } = o;
      n && n(e), te();
    }
    function te() {
      const {
        value: e
      } = y;
      e && (M.value = e.scrollTop, L.value = e.scrollLeft * (r != null && r.value ? -1 : 1));
    }
    function Le() {
      const {
        value: e
      } = pe;
      e && (d.value = e.offsetHeight, h.value = e.offsetWidth);
      const {
        value: n
      } = y;
      n && (T.value = n.offsetHeight, z.value = n.offsetWidth);
      const {
        value: t
      } = p, {
        value: l
      } = B;
      t && (D.value = t.offsetWidth), l && (E.value = l.offsetHeight);
    }
    function le() {
      const {
        value: e
      } = y;
      e && (M.value = e.scrollTop, L.value = e.scrollLeft * (r != null && r.value ? -1 : 1), T.value = e.offsetHeight, z.value = e.offsetWidth, d.value = e.scrollHeight, h.value = e.scrollWidth);
      const {
        value: n
      } = p, {
        value: t
      } = B;
      n && (D.value = n.offsetWidth), t && (E.value = t.offsetHeight);
    }
    function x() {
      o.scrollable && (o.useUnifiedContainer ? le() : (Le(), te()));
    }
    function oe(e) {
      var n;
      return !(!((n = X.value) === null || n === void 0) && n.contains(Je(e)));
    }
    function Ye(e) {
      e.preventDefault(), e.stopPropagation(), j = !0, O("mousemove", window, ie, !0), O("mouseup", window, re, !0), J = L.value, F = r != null && r.value ? window.innerWidth - e.clientX : e.clientX;
    }
    function ie(e) {
      if (!j)
        return;
      m !== void 0 && window.clearTimeout(m), R !== void 0 && window.clearTimeout(R);
      const {
        value: n
      } = z, {
        value: t
      } = h, {
        value: l
      } = V;
      if (n === null || t === null)
        return;
      const u = (r != null && r.value ? window.innerWidth - e.clientX - F : e.clientX - F) * (t - n) / (n - l), b = t - n;
      let i = J + u;
      i = Math.min(b, i), i = Math.max(i, 0);
      const {
        value: w
      } = y;
      if (w) {
        w.scrollLeft = i * (r != null && r.value ? -1 : 1);
        const {
          internalOnUpdateScrollLeft: Y
        } = o;
        Y && Y(i);
      }
    }
    function re(e) {
      e.preventDefault(), e.stopPropagation(), C("mousemove", window, ie, !0), C("mouseup", window, re, !0), j = !1, x(), oe(e) && A();
    }
    function $e(e) {
      e.preventDefault(), e.stopPropagation(), _ = !0, O("mousemove", window, G, !0), O("mouseup", window, k, !0), q = M.value, K = e.clientY;
    }
    function G(e) {
      if (!_)
        return;
      m !== void 0 && window.clearTimeout(m), R !== void 0 && window.clearTimeout(R);
      const {
        value: n
      } = T, {
        value: t
      } = d, {
        value: l
      } = N;
      if (n === null || t === null)
        return;
      const u = (e.clientY - K) * (t - n) / (n - l), b = t - n;
      let i = q + u;
      i = Math.min(b, i), i = Math.max(i, 0);
      const {
        value: w
      } = y;
      w && (w.scrollTop = i);
    }
    function k(e) {
      e.preventDefault(), e.stopPropagation(), C("mousemove", window, G, !0), C("mouseup", window, k, !0), _ = !1, x(), oe(e) && A();
    }
    Oe(() => {
      const {
        value: e
      } = Z, {
        value: n
      } = Q, {
        value: t
      } = S, {
        value: l
      } = p, {
        value: a
      } = B;
      l && (e ? l.classList.remove(`${t}-scrollbar-rail--disabled`) : l.classList.add(`${t}-scrollbar-rail--disabled`)), a && (n ? a.classList.remove(`${t}-scrollbar-rail--disabled`) : a.classList.add(`${t}-scrollbar-rail--disabled`));
    }), Ue(() => {
      o.container || x();
    }), Ie(() => {
      m !== void 0 && window.clearTimeout(m), R !== void 0 && window.clearTimeout(R), C("mousemove", window, G, !0), C("mouseup", window, k, !0);
    });
    const Ee = fe("Scrollbar", "-scrollbar", Fe, ke, o, S), ae = c(() => {
      const {
        common: {
          cubicBezierEaseInOut: e,
          scrollbarBorderRadius: n,
          scrollbarHeight: t,
          scrollbarWidth: l
        },
        self: {
          color: a,
          colorHover: u
        }
      } = Ee.value;
      return {
        "--n-scrollbar-bezier": e,
        "--n-scrollbar-color": a,
        "--n-scrollbar-color-hover": u,
        "--n-scrollbar-border-radius": n,
        "--n-scrollbar-width": l,
        "--n-scrollbar-height": t
      };
    }), W = f ? qe("scrollbar", void 0, ae, o) : void 0;
    return Object.assign(Object.assign({}, {
      scrollTo: ne,
      scrollBy: Te,
      sync: x,
      syncUnifiedContainer: le,
      handleMouseEnterWrapper: ze,
      handleMouseLeaveWrapper: Me
    }), {
      mergedClsPrefix: S,
      rtlEnabled: r,
      containerScrollTop: M,
      wrapperRef: X,
      containerRef: g,
      contentRef: H,
      yRailRef: B,
      xRailRef: p,
      needYBar: Q,
      needXBar: Z,
      yBarSizePx: ve,
      xBarSizePx: me,
      yBarTopPx: Se,
      xBarLeftPx: we,
      isShowXBar: ge,
      isShowYBar: Be,
      isIos: he,
      handleScroll: He,
      handleContentResize: ye,
      handleContainerResize: xe,
      handleYScrollMouseDown: $e,
      handleXScrollMouseDown: Ye,
      cssVars: f ? void 0 : ae,
      themeClass: W == null ? void 0 : W.themeClass,
      onRender: W == null ? void 0 : W.onRender
    });
  },
  render() {
    var o;
    const {
      $slots: S,
      mergedClsPrefix: f,
      triggerDisplayManually: $,
      rtlEnabled: r,
      internalHoistYRail: X
    } = this;
    if (!this.scrollable)
      return (o = S.default) === null || o === void 0 ? void 0 : o.call(S);
    const g = this.trigger === "none", H = (d, h) => v("div", {
      ref: "yRailRef",
      class: [`${f}-scrollbar-rail`, `${f}-scrollbar-rail--vertical`, d],
      "data-scrollbar-rail": !0,
      style: [h || "", this.verticalRailStyle],
      "aria-hidden": !0
    }, v(
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      g ? ue : se,
      g ? null : {
        name: "fade-in-transition"
      },
      {
        default: () => this.needYBar && this.isShowYBar && !this.isIos ? v("div", {
          class: `${f}-scrollbar-rail__scrollbar`,
          style: {
            height: this.yBarSizePx,
            top: this.yBarTopPx
          },
          onMousedown: this.handleYScrollMouseDown
        }) : null
      }
    )), B = () => {
      var d, h;
      return (d = this.onRender) === null || d === void 0 || d.call(this), v("div", je(this.$attrs, {
        role: "none",
        ref: "wrapperRef",
        class: [`${f}-scrollbar`, this.themeClass, r && `${f}-scrollbar--rtl`],
        style: this.cssVars,
        onMouseenter: $ ? void 0 : this.handleMouseEnterWrapper,
        onMouseleave: $ ? void 0 : this.handleMouseLeaveWrapper
      }), [this.container ? (h = S.default) === null || h === void 0 ? void 0 : h.call(S) : v("div", {
        role: "none",
        ref: "containerRef",
        class: [`${f}-scrollbar-container`, this.containerClass],
        style: this.containerStyle,
        onScroll: this.handleScroll,
        onWheel: this.onWheel
      }, v(ce, {
        onResize: this.handleContentResize
      }, {
        default: () => v("div", {
          ref: "contentRef",
          role: "none",
          style: [{
            width: this.xScrollable ? "fit-content" : null
          }, this.contentStyle],
          class: [`${f}-scrollbar-content`, this.contentClass]
        }, S)
      })), X ? null : H(void 0, void 0), this.xScrollable && v("div", {
        ref: "xRailRef",
        class: [`${f}-scrollbar-rail`, `${f}-scrollbar-rail--horizontal`],
        style: this.horizontalRailStyle,
        "data-scrollbar-rail": !0,
        "aria-hidden": !0
      }, v(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        g ? ue : se,
        g ? null : {
          name: "fade-in-transition"
        },
        {
          default: () => this.needXBar && this.isShowXBar && !this.isIos ? v("div", {
            class: `${f}-scrollbar-rail__scrollbar`,
            style: {
              width: this.xBarSizePx,
              right: r ? this.xBarLeftPx : void 0,
              left: r ? void 0 : this.xBarLeftPx
            },
            onMousedown: this.handleXScrollMouseDown
          }) : null
        }
      ))]);
    }, p = this.container ? B() : v(ce, {
      onResize: this.handleContainerResize
    }, {
      default: B
    });
    return X ? v(_e, null, p, H(this.themeClass, this.cssVars)) : p;
  }
}), hn = de, vn = de;
export {
  vn as XScrollbar,
  hn as default
};
